/* Publish by EComposer at 2026-10-18 09:04:41*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-kss61ykuaik"]=  window.__ectimmers["ecom-kss61ykuaik"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-kss61ykuaik').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kss61ykuaik', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mfifwsujqg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mfifwsujqg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kb4kx8wmsu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kb4kx8wmsu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s2sl7teog7f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s2sl7teog7f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5t8axxwzg8e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5t8axxwzg8e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n6r3uivc4us').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n6r3uivc4us', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yf62371isn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yf62371isn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ceu7o2hfliw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ceu7o2hfliw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-36ngi4st8pv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-36ngi4st8pv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g6uh38l7zms').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g6uh38l7zms', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hcuj2kur5u5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hcuj2kur5u5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mu6h3hl28tb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mu6h3hl28tb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mk9jwpb6uqq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mk9jwpb6uqq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nvekeudf9wc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nvekeudf9wc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d7o6iu7y09f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d7o6iu7y09f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uen79cj79xj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uen79cj79xj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c01282g3h3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c01282g3h3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-egtt4buralo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-egtt4buralo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vn8ord2bz7n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vn8ord2bz7n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2yvve2mzsd3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2yvve2mzsd3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vcztjcs07h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vcztjcs07h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3g1xd3ks6wg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3g1xd3ks6wg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hbfbsoo5kff').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hbfbsoo5kff', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kb74phadgha').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kb74phadgha', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7a7xf7zwzuh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7a7xf7zwzuh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-syybkfyky0k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-syybkfyky0k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bm8yo1rwcom').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bm8yo1rwcom', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m8jimx0p9y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m8jimx0p9y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nefmnul349s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nefmnul349s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0dw6vzcrmn5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0dw6vzcrmn5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-163fynusc05').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-163fynusc05', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-puapgwsk5hp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-puapgwsk5hp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1aipy0kt2nr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1aipy0kt2nr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pk4m1hiu4p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pk4m1hiu4p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t6y7hz2dqg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t6y7hz2dqg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iks1ghdh5eq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iks1ghdh5eq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-umh8gmfmog').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-umh8gmfmog', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xgffj2opbl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xgffj2opbl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-85y5w8msak').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-85y5w8msak', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ad00411mfvc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ad00411mfvc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aux5fmw7547').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aux5fmw7547', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yc5odvpbftp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yc5odvpbftp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ua9kuaw5gd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ua9kuaw5gd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o4pmgrbqaqb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o4pmgrbqaqb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u3gdwdd1euq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u3gdwdd1euq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pmc2vuhw817').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pmc2vuhw817', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ihs1hr1ntfc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ihs1hr1ntfc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h7ctn5swhsl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h7ctn5swhsl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d46mca9aa6n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d46mca9aa6n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0ada3miop7k9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0ada3miop7k9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nwvebgqvt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nwvebgqvt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ay9dp8sliwg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ay9dp8sliwg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mjshlb1pj4d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mjshlb1pj4d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0oewtd8g5pc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0oewtd8g5pc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9674u57gyq8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9674u57gyq8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4pmo8k0rczd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4pmo8k0rczd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i08so1k7t3h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i08so1k7t3h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zetd0wet2ao').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zetd0wet2ao', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d8npruivovj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d8npruivovj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vg58yxrf15e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vg58yxrf15e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-21vysf0m7ic').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-21vysf0m7ic', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n651qjqmqm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n651qjqmqm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7nov14hh8iw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7nov14hh8iw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wufs9yjbwm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wufs9yjbwm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f3b7u8z77o4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f3b7u8z77o4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7bw54b61392').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7bw54b61392', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i36lvtntj0p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i36lvtntj0p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e446knzd5t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e446knzd5t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5xrhylrd0k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5xrhylrd0k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uqvo0xtczqb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uqvo0xtczqb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ryqubeooo5i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ryqubeooo5i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0uz3zlk4p1gf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0uz3zlk4p1gf', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-jbt24hin9xr"]=  window.__ectimmers["ecom-jbt24hin9xr"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-jbt24hin9xr"]["h9zvojogt"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-jbt24hin9xr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jbt24hin9xr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v3c2d1tmxln').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v3c2d1tmxln', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r99qc41wrpo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r99qc41wrpo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xe4yb6xy81').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xe4yb6xy81', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7jvsm0wmod8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7jvsm0wmod8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-olvpts99ngd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-olvpts99ngd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bvpoq0f7ril').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bvpoq0f7ril', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zgk6nehavnm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zgk6nehavnm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-acicsdmguq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-acicsdmguq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p88jm8w8y1i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p88jm8w8y1i', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gmsy0rvcqmi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gmsy0rvcqmi', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-duob5jsy6qf"]=  window.__ectimmers["ecom-duob5jsy6qf"] || {};
if(!this.$el)return;let t=this.$el;this.isLive;var e=this.id;const i=function(){const n=document.querySelectorAll(".ecom-container-lightbox-"+e);n.length&&n.forEach(function(r){const a=r.querySelector("iframe");a!=null&&(a.contentWindow.postMessage('{"method":"pause"}',"*"),a.src="");const l=r.querySelector("video");l!=null&&l.pause()})},s=function(n){if(window.EComModal)return n();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&n()});return}let r=0;const a= window.__ectimmers["ecom-duob5jsy6qf"]["nyg8vnxm5"] = setInterval(function(){window.EComModal?(clearInterval(a),n()):++r>=300&&clearInterval(a)},50)},o=this.id;t&&s(function(){var n=t.querySelector("[ecom-modal]");new window.EComModal(n,{cssClass:["ecom-container-lightbox-"+o,"ecom-html","ecom-modal","ecommodal-slide"],onOpen:function(){const r=document.querySelectorAll(".ecom-container-lightbox-"+e);r.length&&(r.forEach(function(a){const l=a.querySelector("iframe");if(l!=null){const d=l.src.replace("muted=1","muted=0").replace("mute=1","mute=0");l.src=d}const c=a.querySelector("video");c!=null&&c.play()}),window.dispatchEvent(new CustomEvent("ecom-lightbox-opened",{detail:{id:e,el:r}})))},onClose:i})}),i()

                    });
                    
                        document.querySelectorAll('.ecom-duob5jsy6qf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-duob5jsy6qf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f28lerbu3r5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f28lerbu3r5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8nosfujp6wa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8nosfujp6wa', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-s83vrwtsww"]=  window.__ectimmers["ecom-s83vrwtsww"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-s83vrwtsww"]["e350uetyq"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-s83vrwtsww').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s83vrwtsww', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gghp2q87d1u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gghp2q87d1u', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p9n97d7nkz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p9n97d7nkz', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a8gagvn7bgp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a8gagvn7bgp', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5cor709be1l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5cor709be1l', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pf6ffq4ujg9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pf6ffq4ujg9', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6v84151x2en').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6v84151x2en', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f9fmzra1pm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f9fmzra1pm', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z7cgs9ahk1r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z7cgs9ahk1r', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x6lpssgzv6j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x6lpssgzv6j', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8k0w2twd2f6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8k0w2twd2f6', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xziqcjgtre').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xziqcjgtre', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}